/**
 * Alert to Toast Conversion
 * Replaces all standard browser alerts with customized toast notifications
 */

document.addEventListener('DOMContentLoaded', function() {
  // Make sure the toast system is loaded first
  if (typeof window.toast === 'undefined') {
    console.warn('Toast notification system is not available. Creating a fallback.');
    // Create a simple fallback if toast.js hasn't loaded yet
    window.toast = {
      success: function(message) { console.log('Success toast:', message); },
      error: function(message) { console.log('Error toast:', message); },
      info: function(message) { console.log('Info toast:', message); },
      warning: function(message) { console.log('Warning toast:', message); }
    };
  }
  
  // Store the original alert function
  const originalAlert = window.alert;
  
  // Override the alert function with our toast version
  window.alert = function(message) {
    // If message mentions error, use error toast
    if (message && (
        message.toLowerCase().includes('error') || 
        message.toLowerCase().includes('invalid') ||
        message.toLowerCase().includes('failed') ||
        message.toLowerCase().includes('ผิดพลาด') ||
        message.toLowerCase().includes('ล้มเหลว')
    )) {
      return window.toast.error(message);
    } 
    // Success-like messages
    else if (message && (
        message.toLowerCase().includes('success') ||
        message.toLowerCase().includes('added') ||
        message.toLowerCase().includes('complete') || 
        message.toLowerCase().includes('thank') ||
        message.toLowerCase().includes('สำเร็จ') ||
        message.toLowerCase().includes('ขอบคุณ') ||
        message.toLowerCase().includes('เพิ่ม') && message.toLowerCase().includes('แล้ว')
    )) {
      return window.toast.success(message);
    }
    // All other messages default to info type
    else {
      return window.toast.info(message);
    }
  };
  
  console.log('Alert to Toast conversion enabled');
  
  // Apply fix to specific theme.js alerts by hooking into AJAX responses
  const originalJQueryAjax = $.ajax;
  if ($ && $.ajax) {
    $.ajax = function(options) {
      // Create a wrapper for the error callback
      if (options && options.error) {
        const originalErrorCallback = options.error;
        options.error = function(xhr, text, error) {
          // Convert any alerts in the callback to toasts
          try {
            // Let the original callback run
            const result = originalErrorCallback.apply(this, arguments);
            return result;
          } catch (e) {
            console.error('Error in AJAX error handler:', e);
          }
        };
      }
      
      return originalJQueryAjax.apply(this, arguments);
    };
  }
});
